import {
  put, takeLatest, takeEvery, select, all, putResolve,
  take,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  organisationAddressSchema,
  organisationAddressListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/organisationAddresses/actions';
import { getOrganisation } from 'app/ducks/organisations/actions';
import { OrganisationAddressesActionTypes as types } from 'app/ducks/organisationAddresses/types';
import { OrganisationsActionTypes } from '../organisations/types';

function* createOrganisationAddressSaga(action): any {
  yield put(sagaActions.createOrganisationAddressPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationAddresses.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, organisationAddressSchema);
    yield putResolve(yield getOrganisation(action.payload.organisation.id));

    yield take(OrganisationsActionTypes.GET_ORGANISATION_SUCCESS);

    yield put(sagaActions.createOrganisationAddressSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createOrganisationAddressFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateOrganisationAddressSaga(action): any {
  yield put(sagaActions.updateOrganisationAddressPending(action.payload));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationAddresses.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, organisationAddressSchema);

    yield put(sagaActions.updateOrganisationAddressSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateOrganisationAddressFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getOrganisationAddressSaga(action): any {
  yield put(sagaActions.getOrganisationAddressPending());

  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationAddresses.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, organisationAddressSchema);
    yield put(sagaActions.getOrganisationAddressSuccess(normalizedResponse));
    return normalizedResponse.entities.organisationAddresses[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getOrganisationAddressFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllOrganisationAddressesSaga(action): any {
  yield put(
    sagaActions.getAllOrganisationAddressesPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.organisationAddresses.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationAddresses.list(paginationObject);

  if (response) {
    const normalizedResponse = normalize(
      response,
      organisationAddressListSchema,
    );

    yield put(
      sagaActions.getAllOrganisationAddressesSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllOrganisationAddressesFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createOrganisationAddressSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_ORGANISATION_ADDRESS_REQUESTED,
    createOrganisationAddressSaga,
  );
}

function* updateOrganisationAddressSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_ORGANISATION_ADDRESS_REQUESTED,
    updateOrganisationAddressSaga,
  );
}

function* getOrganisationAddressSagaWatcher(): any {
  yield takeLatest(
    types.GET_ORGANISATION_ADDRESS_REQUESTED,
    getOrganisationAddressSaga,
  );
}

function* getAllOrganisationAddressesSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_ORGANISATION_ADDRESSES_REQUESTED,
    getAllOrganisationAddressesSaga,
  );
}

export default function* root(): any {
  yield all([
    createOrganisationAddressSagaWatcher(),
    updateOrganisationAddressSagaWatcher(),
    getOrganisationAddressSagaWatcher(),
    getAllOrganisationAddressesSagaWatcher(),
  ]);
}
